export const actions = {
    GET_DATA_REQUEST: "GET_DATA_REQUEST",
    GET_DATA_SUCCESS: "GET_DATA_SUCCESS",
    GET_DATA_FAILURE: "GET_DATA_FAILURE",
  };
  